import axios from '@/utils/axios'
import { perPage } from '@/config'
import { formatTopSongs } from '@/utils/song'

axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL

// 排行榜列表
export function getToplistDetail() {
  return axios.get('/toplist/detail')
}

// 推荐歌单
export function getPersonalized() {
  return axios.get('/personalized')
}

// 歌单详情
export function getPlaylistDetail(id) {
  return new Promise((resolve, reject) => {
    axios
      .get('/playlist/detail/' + id)
      .then(({ playlist }) => playlist || {})
      .then(playlist => {
        const { worshipHymnIds, worshipHymns } = playlist
        if (!Array.isArray(worshipHymnIds)) {
          reject(new Error('获取歌单详情失败'))
          return
        }
        // 过滤完整歌单 如排行榜
        if (worshipHymns.length === worshipHymnIds.length) {
          playlist.worshipHymns = formatTopSongs(playlist.worshipHymns)
          resolve(playlist)
          return
        }
        // 限制歌单详情最大 500
        const ids = worshipHymnIds
          .slice(0, 500)
          .map(v => v.id)
          .toString()
        getMusicDetail(ids).then(({ songs }) => {
          playlist.worshipHymns = formatTopSongs(songs)
          resolve(playlist)
        })
      })
  })
}

// 搜索
export function search(name, page = 0, per_page = perPage) {
  return axios.get('/search', {
    params: {
      page: page,
      per_page: per_page,
      name
    }
  })
}

// 热搜
export function searchHot() {
  return axios.get('/search/hot')
}

// 获取用户歌单详情
export function getUserPlaylist(uid) {
  return axios.get('/user/playlist', {
    params: {
      uid
    }
  })
}

// 获取歌曲详情
export function getMusicDetail(ids) {
  return axios.get('/song/detail/' + ids)
}

// 获取音乐是否可以用
export function getCheckMusic(id) {
  return axios.get('/check/music', {
    params: {
      id
    }
  })
}

// 获取音乐地址
export function getMusicUrl(id) {
  return axios.get('/song/url', {
    params: {
      id
    }
  })
}

// 获取歌词
export function getLyric(id) {
  const url = '/lyric/' + id
  return axios.get(url)
}

// 获取歌谱
export function getSpectrum(id) {
  const url = '/spectrum/' + id
  return axios.get(url)
}

// 获取音乐评论
export function getComment(name, page = 0, per_page = 15) {
  return axios.get('/search', {
    params: {
      page: page,
      per_page: per_page,
      name
    }
  })
}
